module.exports = __webpack_public_path__ + "static/img/丽企之家驾驶舱@4x.7f14bb90.png";